/* eslint-disable */
import { useMemo } from "react";
import { isEqual } from "lodash";
import { useCalendarValue } from "./useCalendarValue";
import { useCalendarMultiple } from "./useCalendarMultiple";
import { ICalendarSelectorGroup, CalendarMultipleValueType } from "../types";

export function useCancel(groups: ICalendarSelectorGroup[], updateGroups: (groups: ICalendarSelectorGroup[]) => void) {
  const [value] = useCalendarValue();
  const multiple = useCalendarMultiple();

  return useMemo(
    () => () => {
      const result: ICalendarSelectorGroup[] = [];
      const values = (multiple ? value : [value]) as CalendarMultipleValueType;
      const notNullArr = (values || []).filter(Boolean);

      for (const group of groups) {
        const items = group.items.map((x) => ({ ...x, active: notNullArr.includes(x.item.id) }));
        result.push({ ...group, items });
      }
      updateGroups(result);
    },
    [groups],
  );
}
